var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterestnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "rgb(2, 131, 131)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 17.3333C21.66 16.36 22.6667 15.1933 22.6667 13.6667C22.6667 12.6942 22.2804 11.7616 21.5928 11.0739C20.9051 10.3863 19.9725 10 19 10C17.8267 10 17 10.3333 16 11.3333C15 10.3333 14.1734 10 13 10C12.0276 10 11.0949 10.3863 10.4073 11.0739C9.71968 11.7616 9.33337 12.6942 9.33337 13.6667C9.33337 15.2 10.3334 16.3667 11.3334 17.3333L16 22L20.6667 17.3333Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestnew);
export default __webpack_public_path__ + "static/media/Interestnew.b1baef4bdc922af4843ef1d742852c9f.svg";
export { ForwardRef as ReactComponent };